export const userAgentOptions = {
	allowHigherVersions: true,
	ignoreMinor: true,
	ignorePatch: true,
};
